import { BaseAPI } from "@utils/base-api";
import { GetPostCheckoutChargesResponseDto } from "@./types/charges";

import {
  CHARGES_CUSTOMER_GET_POST_CHECKOUT_CHARGES_PATH,
  CHARGES_CUSTOMER_GET_POST_CHECKOUT_CHARGES_PATH_LEGACY,
} from "./constants/endpoint-paths";

export class ChargesAPI extends BaseAPI {

  public async getPostCheckoutChargesLegacy(katkinCustomerId?: string): Promise<GetPostCheckoutChargesResponseDto> {
    try {
      const response = await this.axios.get(CHARGES_CUSTOMER_GET_POST_CHECKOUT_CHARGES_PATH_LEGACY, {
        params: {
          katkinCustomerId,
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error getting charges post checkout", error);
      throw error;
    }

  }

  public async getPostCheckoutCharges(): Promise<GetPostCheckoutChargesResponseDto> {
    try {
      const response = await this.axios.get(CHARGES_CUSTOMER_GET_POST_CHECKOUT_CHARGES_PATH, {
      });
      return response.data;
    } catch (error) {
      console.error("Error getting charges post checkout", error);
      throw error;
    }

  }

}
